import script from "./AllProjects.vue?vue&type=script&setup=true&lang=js"
export * from "./AllProjects.vue?vue&type=script&setup=true&lang=js"

import "./AllProjects.vue?vue&type=style&index=0&id=bb296228&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb296228"]])

export default __exports__